import { Head, Link } from "@inertiajs/react"
import { ArrowLeft } from "lucide-react"
import { useTranslation } from "react-i18next"

import { MasterclassForm } from "@/components/masterclasses/masterclass-form"
import AppLayout from "@/layouts/app-layout"
import { masterclassPath } from "@/routes"
import type { MasterclassFormProps } from "@/types/masterclasses"

/**
 * OKS-54 — `Brand/Masterclasses/Edit`.
 *
 * Page chrome (breadcrumb back to Show + title) + the shared
 * `<MasterclassForm>` body in `edit` mode. Symmetric with `New`.
 */
export default function MasterclassesEdit({
  masterclass,
}: MasterclassFormProps) {
  const { t } = useTranslation()

  return (
    <AppLayout>
      <Head title={t("masterclasses.form.edit_title")} />
      <div
        className="mx-auto flex w-full max-w-5xl flex-col gap-6 p-6"
        data-testid="masterclass-edit-page"
      >
        <header className="flex flex-col gap-3">
          <Link
            href={masterclassPath(masterclass.id ?? 0)}
            className="text-muted-foreground hover:text-foreground inline-flex w-fit items-center gap-1 text-sm"
            data-testid="masterclass-edit-back-link"
          >
            <ArrowLeft className="size-4" aria-hidden="true" />
            {masterclass.title}
          </Link>
          <h1 className="text-foreground text-2xl font-semibold tracking-tight">
            {t("masterclasses.form.edit_title")}
          </h1>
        </header>

        <MasterclassForm masterclass={masterclass} mode="edit" />
      </div>
    </AppLayout>
  )
}
